<template>
  <button @click="action(value)">
    <slot name="body"></slot>
  </button>
</template>

<script>
export default {
  props: {
    action: {
      type: Function
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_ButtonText";
</style>